export * from './useDetailRow';
